import SinglePropChainTracker from "../../prop-tracker-utils/single-prop-chain-tracker.js";
import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";

class SlideEnvLight {
    constructor(wrapCtx, evtCtx) {
        this._envTracker = new SinglePropChainTracker(evtCtx);
        this._envGen = new ValueTrackerObjGen(wrapCtx, evtCtx, this._envTracker);
    }

    get envLight() { return this._envGen; }

    track(slide) {
        if (slide) {
            this._envTracker.track(slide.data, ["value", "envLight"]);
        } else {
            this._envTracker.track();
        }
    }

    update() {
        this._envGen.update();
    }
}

export default SlideEnvLight;
